/**
 * SEO 配置中心 & 动态 Meta 管理工具
 * 
 * 由于项目 Vue 2 通过 CDN 外部加载（externals），无法使用 vue-meta 插件，
 * 因此采用轻量级的手动 DOM 操作方式管理页面的 SEO 信息。
 * 
 * @author cjy
 * @since 2026-06-02
 */

const SITE_NAME = '易企化';
const SITE_DOMAIN = 'https://www.yqihua.com';
const SITE_LOGO = 'https://mpjoy.oss-cn-beijing.aliyuncs.com/20260528/5f80f5bc2b89481cadf6e2c951effd3f.png';

/**
 * 各页面 SEO 配置表
 * key = 路由 name（对应 router/index.js 中的 name 字段）
 */
const SEO_CONFIG = {
    index: {
        title: '易企化 - AI 自助记账报税平台 | 698元/年起',
        description: '易企化 AI 财税管家，面向小微企业和个体户，698元/年起自动记账、专业审账、官方报税。四年套餐买三赠一，价格透明。',
        keywords: '易企化, AI记账, 自助记账, 自动记账报税, 小微企业报税, 个体户记账',
    },
    product: {
        title: '产品功能 - 易企化自动记账报税全流程',
        description: '了解易企化六步自动记账报税流程：发票采集、银行流水同步、自动生成凭证、财务报表、专业复核、一键报税。',
        keywords: '易企化产品, 自动记账功能, 发票采集, 银行流水, 财务报表, 一键报税',
    },
    features: {
        title: '产品功能 - 易企化自动记账报税全流程',
        description: '了解易企化六步自动记账报税流程：发票采集、银行流水同步、自动生成凭证、财务报表、专业复核、一键报税。',
        keywords: '易企化产品, 自动记账功能, 发票采集, 银行流水, 财务报表, 一键报税',
    },
    compare: {
        title: '市场对比 - 易企化 vs 传统代账公司',
        description: '易企化与传统代理记账公司全面对比：价格更低、效率更高、数据更透明、官方责任兜底。看清差距，选对平台。',
        keywords: '记账对比, 代理记账, 代账公司对比, 易企化优势, 记账报税价格对比',
    },
    cases: {
        title: '行业案例 - 易企化服务客户案例展示',
        description: '查看易企化在餐饮、零售、电商、服务业等多个行业的记账报税成功案例，了解真实客户使用体验。',
        keywords: '记账案例, 报税案例, 行业案例, 小微企业案例, 易企化客户',
    },
    example: {
        title: '行业案例 - 易企化服务客户案例展示',
        description: '查看易企化在餐饮、零售、电商、服务业等多个行业的记账报税成功案例，了解真实客户使用体验。',
        keywords: '记账案例, 报税案例, 行业案例, 小微企业案例, 易企化客户',
    },
    packages: {
        title: '优惠套餐 - 易企化记账报税价格方案',
        description: '易企化提供零申报、小规模企业、一般纳税人套餐，698元/年起；四年长期套餐按三年付费，价格透明，按需选择。',
        keywords: '记账价格, 报税套餐, 记账报税多少钱, 小规模纳税人记账, 一般纳税人报税',
    },
    partners: {
        title: '全国合伙人招募 - 易企化 AI 财税管家',
        description: '易企化 AI 财税管家面向全国招募渠道合作伙伴与城市运营伙伴，提供产品、培训、物料、交付和运营支持。',
        keywords: '易企化合伙人, 财税代理, 渠道合作, 城市合伙人, 企业服务合作',
    },
    help: {
        title: '帮助中心 - 易企化常见问题解答',
        description: '易企化帮助中心，解答关于注册登录、记账报税、发票管理、银行流水、报表查看等常见问题。',
        keywords: '易企化帮助, 记账帮助, 报税常见问题, FAQ, 使用教程',
    },
    calculator: {
        title: '省钱测算 - 记账报税一年能省多少钱？| 易企化',
        description: '30秒测算您的公司用易企化记账报税能省多少钱：对比自请会计与代理记账成本，零申报698元/年起，四年按三年付费，立即生成专属省钱报告。',
        keywords: '记账报税价格, 记账费用测算, 代理记账多少钱, 自请会计成本, 易企化省钱计算',
    },
    contact: {
        title: '联系我们 - 易企化客服咨询电话',
        description: '联系易企化客服团队：139-5011-2024，周一至周五 9:00-18:00 在线服务。厦门总部地址：思明区瑞达国际金融中心。',
        keywords: '易企化联系方式, 客服电话, 厦门记账公司, 财税咨询',
    },
    login: {
        title: '用户登录 - 易企化记账报税平台',
        description: '登录易企化记账报税平台，管理您的企业财务数据。',
        keywords: '易企化登录, 记账登录, 用户登录',
    },
    about: {
        title: '关于我们 - 易企化（福建）科技有限公司',
        description: '了解易企化（福建）科技有限公司，厦门总部，专注为小微企业提供 AI 智能财税解决方案，让老板轻松管账、放心经营。',
        keywords: '易企化公司, 关于易企化, 福建科技公司, 厦门财税公司',
    },
    appDownload: {
        title: 'APP 下载 - 易企化移动端记账报税',
        description: '下载易企化 APP，支持 iOS、Android、鸿蒙系统，随时随地管理企业财税，手机记账报税更便捷。',
        keywords: '易企化APP, 记账APP下载, 报税APP, 移动端记账',
    },
    news: {
        title: '新闻动态 - 易企化最新资讯',
        description: '了解易企化最新产品动态、行业资讯和财税政策解读。',
        keywords: '易企化新闻, 财税资讯, 行业动态',
    },
    productDetails: {
        title: '产品详情 - 易企化',
        description: '查看易企化产品的详细功能介绍和使用说明。',
        keywords: '易企化产品, 产品详情, 功能介绍',
    },
    newsDetails: {
        title: '新闻详情 - 易企化',
        description: '查看易企化新闻资讯详情。',
        keywords: '易企化新闻, 资讯详情',
    },
};

/**
 * 更新页面的 SEO meta 信息
 * @param {string} routeName - 路由 name
 * @param {string} routePath - 路由 path
 * @param {object} [override] - 覆盖特定字段（用于动态页面如新闻详情）
 */
export function updateSeoMeta(routeName, routePath, override = {}) {
    const config = SEO_CONFIG[routeName] || {};
    const title = override.title || config.title || `${SITE_NAME} - AI 自助记账报税平台`;
    const description = override.description || config.description || '易企化 AI 财税管家，面向小微企业和个体户，自动记账、专业审账、官方报税。';
    const keywords = override.keywords || config.keywords || '易企化, 自助记账, 自动记账报税';
    const canonicalUrl = `${SITE_DOMAIN}${routePath}`;

    // 1. 更新 document.title
    document.title = title;

    // 2. 更新/创建 meta 标签
    setMetaTag('name', 'description', description);
    setMetaTag('name', 'keywords', keywords);

    // 3. 更新 canonical 链接
    setLinkTag('canonical', canonicalUrl);

    // 4. 更新 Open Graph 标签
    setMetaTag('property', 'og:title', title);
    setMetaTag('property', 'og:description', description);
    setMetaTag('property', 'og:url', canonicalUrl);
    setMetaTag('property', 'og:site_name', SITE_NAME);
    setMetaTag('property', 'og:type', 'website');
    setMetaTag('property', 'og:image', override.image || SITE_LOGO);
    setMetaTag('property', 'og:locale', 'zh_CN');
}

/**
 * 设置或创建 meta 标签
 */
function setMetaTag(attr, key, value) {
    let el = document.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute('content', value);
}

/**
 * 设置或创建 link 标签
 */
function setLinkTag(rel, href) {
    let el = document.querySelector(`link[rel="${rel}"]`);
    if (!el) {
        el = document.createElement('link');
        el.setAttribute('rel', rel);
        document.head.appendChild(el);
    }
    el.setAttribute('href', href);
}

export default SEO_CONFIG;
